export default "__VITE_ASSET__5vsEQSvs__"